import { AdminTribeReportHTML } from './AdminTribeReportHTML';

export default AdminTribeReportHTML;